<template>
  <div id="app">

    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  directives: {
    'scroll-animation': {
      mounted(el) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('animate__animated', 'animate__fadeInUp');
              observer.unobserve(el);
            }
          });
        }, {
          threshold: 0.1
        });
        observer.observe(el);
      }
    }
  }
}
</script>

<style lang='scss'>
@import 'animate.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*{
  padding: 0;
  margin: 0;
}


[v-scroll-animation] {
  opacity: 0;
}

.animate__animated {
  opacity: 1;
  --animate-duration: 0.8s;
}
</style>
